export default ["Role", "User", (Role, User) => ({
  tableList(page, filterParams) {
    return User.page(page, { filter: filterParams }).then((users) =>
      Role.loadListBelongsTo(users, 'role', 'roleId').then(() => users)
    )
  }
})];
